import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, Inject, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[ecpDynamicChatScript]',
  standalone: false,
})
export class DynamicChatScriptDirective implements AfterViewInit {
  constructor(
    private el: ElementRef,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngAfterViewInit() {
    const templateEl = this.el.nativeElement.firstElementChild as HTMLElement;
    if (templateEl) {
      void this.replaceDivWithScript(templateEl);
    }
  }

  private async replaceDivWithScript(templateEl: HTMLElement): Promise<void> {
    const scriptContent = templateEl.textContent?.trim();
    templateEl.remove();

    if (!scriptContent) {
      return;
    }

    const scriptPath = `assets/js/${scriptContent}.js`;
    const scriptAvailable = await this.scriptExists(scriptPath);
    if (!scriptAvailable) {
      return;
    }

    const script = this.document.createElement('script');
    script.src = scriptPath;
    script.defer = true;
    // this.copyAttributesFromTemplateToScript(templateEl, script);
    // this.copyTemplateContentToScript(templateEl, script);

    // add the new script element to the host div so the browser will execute it
    this.el.nativeElement.appendChild(script);
  }

  private async scriptExists(scriptPath: string): Promise<boolean> {
    try {
      const scriptUrl = new URL(scriptPath, this.document.baseURI).toString();
      const response = await fetch(scriptUrl, { method: 'HEAD' });
      return response.ok;
    } catch {
      return false;
    }
  }

  // private copyAttributesFromTemplateToScript(templateEl: HTMLElement, script: HTMLScriptElement) {
  // 	for (let a = 0; a < templateEl.attributes.length; a++) {
  // 		script.attributes.setNamedItem(templateEl.attributes[a].cloneNode() as Attr);
  // 	}
  // }

  // private copyTemplateContentToScript(templateEl: HTMLElement, script: HTMLScriptElement) {
  // 	const scriptContent = this.document.createTextNode(templateEl.textContent);
  // 	script.appendChild(scriptContent);
  // }
}
